import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import appModule from '@/store/app/'
import userModule from '@/store/user/'
import valuationProcessModule from '@/store/valuation/'
import valuationRecordsModule from '@/store/valuation/records'
import valuationSearchModule from '@/store/valuation/search'
import valuationEditModule from '@/store/valuation/edit'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app: appModule,
    user: userModule,
    valuationProcess: valuationProcessModule,
    valuationRecords: valuationRecordsModule,
    valuationSearch: valuationSearchModule,
    valuationEdit: valuationEditModule,
  },
  plugins: [
    createPersistedState({
      paths: ['user'],
    }),
  ],
})
